import { render } from "./Users.vue?vue&type=template&id=55bfdd92&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "../assets/css/table.css?vue&type=style&index=0&id=55bfdd92&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bfdd92"]])

export default __exports__